module.exports = __webpack_public_path__ + "img/audio_classify5.37601de4.png";